export const KNIGHT_GRADED_KEYS = new Set([
  'active',
  'charge_run1',
  'charge_run2',
  'defeat',
  // 崩れから構えへ立ち上がる2枚 (10-30・src/boss_rise.ts)。同じ grade() で揃え、暗部の持ち上がりだけ抑えた。
  'rise1',
  'rise2',
  // 固有の致命 (DEV ?execUnique=1) の3枚。10-09 槍を今の長さへ縮めてから同じ grade() で揃えた (scripts/knight_exec_unique_art.py)。
  'exec_backcoil_1009',
  'exec_backturn_1009',
  'exec_turnmid_1009',
  'knightExecution_impale',
  'knightExecution_windup',
  'lanceButt_contact',
  'lanceButt_slam',
  'lanceButt_windup',
  'lanceCross_backClose',
  'lanceCross_backPlant',
  'lanceCross_contact',
  'lanceCross_recover',
  'lanceCross_stepback',
  'lanceCross_windup',
  'lanceDouble_gap',
  'lanceGround_contact',
  'lanceGround_windup',
  'lanceShove_contact',
  'lanceShove_windup',
  'lanceSweep_contact',
  'lanceSweep_cut',
  'lanceSweep_holdOn',
  'lanceSweep_linkWindup',
  'lanceSweep_ready',
  'lanceSweep_rearm',
  'lanceSweep_rearmMid',
  'lanceSweep_turn',
  'lanceSweep_windup',
  'lanceThrust_coilStart',
  'lanceThrust_full',
  'lanceThrust_linkWindup',
  'lanceThrust_overextend',
  'lanceThrust_recover',
  'lanceThrust_strike',
  'lanceThrust_windup',
  'leap_swing',
  'parried',
  'scrape_stop',
  'staggered',
  'suri_draw',
  'suri_open',
  'telegraph',
  'turn',
  'walk_passing',
  'walk_reach',
])

export function knightColorGradedEnabled(): boolean {
  if (import.meta.env.DEV) {
    return new URLSearchParams(globalThis.location?.search ?? '').get('knightColor') !== 'original'
  }
  return true
}

export function knightSpriteSource(bossId: string, key: string, stem: string, ext: string, graded: boolean): string {
  const folder = graded && bossId === 'vigil-knight' && KNIGHT_GRADED_KEYS.has(key) && stem === key ? 'graded/' : ''
  return `/sprites/bosses/${bossId}/${folder}${stem}.${ext}`
}
